import { Link } from "react-router-dom";
import { ArrowUpRight, Check } from "lucide-react";
import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { CTASection } from "@/pages/Home";
import useSEO from "@/hooks/useSEO";
import { SERVICES } from "@/data/content";

const Services = () => {
  useSEO(
    "Services — SSDE LTD | Branding, Packaging, Web & UI Design",
    "Explore SSDE LTD's specialised design services: graphic design, logo design, branding, brochures, packaging, website layouts, UI design and digital content."
  );
  return (
    <>
      <PageHero
        testId="services-hero"
        eyebrow="Our Services"
        titleLines={["Specialised", "Design Services."]}
        lede="Eight disciplines, one standard: considered, professional design that helps your brand communicate clearly and consistently."
      />

      <section className="bg-white py-20 sm:py-28" data-testid="services-list">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 space-y-20 sm:space-y-28">
          {SERVICES.map((s, i) => (
            <Reveal key={s.slug}>
              <article
                id={s.slug}
                data-testid={`service-detail-${s.slug}`}
                className={`scroll-mt-28 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center ${
                  i % 2 === 1 ? "" : ""
                }`}
              >
                <div className={`lg:col-span-6 ${i % 2 === 1 ? "lg:order-2" : ""}`}>
                  <figure className="group relative overflow-hidden border border-line bg-offwhite">
                    <img
                      src={s.image}
                      alt={s.alt}
                      className="w-full aspect-[4/3] object-cover transition-transform duration-700 ease-out group-hover:scale-[1.03]"
                      loading="lazy"
                    />
                    <span className="absolute top-4 left-4 bg-white/95 border border-line px-3 py-1.5 font-mono text-[10px] uppercase tracking-[0.2em] text-gold-deep">
                      {String(i + 1).padStart(2, "0")} / 08
                    </span>
                  </figure>
                </div>
                <div className={`lg:col-span-6 ${i % 2 === 1 ? "lg:order-1" : ""}`}>
                  <p className="eyebrow mb-4">Service {String(i + 1).padStart(2, "0")}</p>
                  <h2 className="font-serif text-2xl sm:text-3xl lg:text-4xl tracking-tight text-charcoal leading-[1.15]">
                    {s.title}
                  </h2>
                  <p className="mt-5 text-base text-charcoal-mute leading-relaxed max-w-xl">{s.short}</p>
                  <ul className="mt-7 space-y-3">
                    {s.highlights.map((h) => (
                      <li key={h} className="flex items-start gap-3 text-sm text-charcoal">
                        <span className="mt-0.5 inline-flex items-center justify-center w-5 h-5 border border-gold/50 bg-ivory text-gold-deep shrink-0">
                          <Check size={12} strokeWidth={2.2} />
                        </span>
                        {h}
                      </li>
                    ))}
                  </ul>
                  <Link
                    to={`/contact?service=${s.slug}`}
                    data-testid={`service-discuss-button-${s.slug}`}
                    className="btn-outline mt-9"
                  >
                    Discuss This Service
                    <ArrowUpRight size={15} strokeWidth={1.8} />
                  </Link>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </section>

      <CTASection />
    </>
  );
};

export default Services;
